import { PRODUCT_CATEGORY_IDS, PRODUCT_IDS } from "@chef/constants";
import { getSectionData } from "@chef/feature-sanity";
import { getWeek, getYear, nextDeliveryWeekDateObj } from "@chef/helpers";
import { api, storeWrapper } from "@chef/state-management";

export const SignupSelectPreferencesGetStaticProps =
  storeWrapper.getStaticProps((store) => async (ctx) => {
    const nextDelivery = nextDeliveryWeekDateObj();

    const week = getWeek(nextDelivery);
    const year = getYear(nextDelivery);

    store.dispatch(api.endpoints.defaultCoupon.initiate());

    store.dispatch(
      api.endpoints.productsByIds.initiate({
        productIds: [PRODUCT_IDS.ONESUB],
        week,
        year,
      }),
    );

    store.dispatch(api.endpoints.preferences.initiate());

    const [
      signup_step_one,
      signup_step_one_bottom_content,
      signup_step_one_banner,
    ] = await Promise.all([
      getSectionData("signup_step_one", { preview: ctx.preview }),
      getSectionData("signup_step_one_bottom_content", {
        preview: ctx.preview,
      }),
      getSectionData("signup_step_one_banner", {
        preview: ctx.preview,
      }),
      ...store.dispatch(api.util.getRunningQueriesThunk()),
    ]);

    return {
      props: {
        draftMode: ctx.preview || false,
        signupStepOne: signup_step_one || null,
        signupStepOneBottomContent: signup_step_one_bottom_content || null,
        signupStepOneBanner: signup_step_one_banner || null,
      },
      revalidate: 600,
    };
  });

export const SignupPaymentGetStaticProps = storeWrapper.getStaticProps(
  (store) => async (ctx) => {
    const currentDate = nextDeliveryWeekDateObj();

    const currentWeek = getWeek(currentDate);
    const currentYear = getYear(currentDate);
    await store
      .dispatch(
        api.endpoints.productsByCategories.initiate({
          week: currentWeek,
          year: currentYear,
          categoryIds: [PRODUCT_CATEGORY_IDS.MEALBOX_LOGGED_OUT],
        }),
      )
      .unwrap();

    const signup_step_four = await getSectionData("signup_step_four", {
      preview: ctx.preview,
    });

    return {
      props: {
        draftMode: ctx.preview || false,
        signupStepFour: signup_step_four || null,
      },
      revalidate: 600,
    };
  },
);

export const SignupCreateAccountGetStaticProps = storeWrapper.getStaticProps(
  () => async (ctx) => {
    const signup_step_two = await getSectionData("signup_step_two", {
      preview: ctx.preview,
    });

    return {
      props: {
        draftMode: ctx.preview || false,
        signupStepTwo: signup_step_two || null,
      },
      revalidate: 600,
    };
  },
);

export const SignupCreateDeliveryDetailsGetStaticProps =
  storeWrapper.getStaticProps(() => async (ctx) => {
    const [
      signup_step_three,
      signup_step_three_delivery_modal,
      signup_step_three_delivery_interval_modal,
    ] = await Promise.all([
      getSectionData("signup_step_three", { preview: ctx.preview }),
      getSectionData("signup_step_three_delivery_modal", {
        preview: ctx.preview,
      }),
      getSectionData("signup_step_three_delivery_interval_modal", {
        preview: ctx.preview,
      }),
    ]);

    return {
      props: {
        draftMode: ctx.preview || false,
        signupStepThree: signup_step_three || null,
        signupStepThreeDeliveryModal: signup_step_three_delivery_modal || null,
        signupStepThreeDeliveryIntervalModal:
          signup_step_three_delivery_interval_modal || null,
      },
      revalidate: 600,
    };
  });
